import { getConnectionManager, HubConnectionManager } from 'common/streaming/hubConnectionManager';
import IDispatcher from "common/dispatcher";
import producerService from './producerService';
import { ProducerUpdated } from './producers.action';

interface IProducerEventStreamingService {
    start(dispatcher: IDispatcher): Promise<void>;
}

class ProducerEventStreamingService implements IProducerEventStreamingService {
    private hubConnectionManager: HubConnectionManager;
    private dispatcher: IDispatcher;
    private isStarted: boolean;

    constructor() {
        this.hubConnectionManager = getConnectionManager();
    }

    public async start(dispatcher: IDispatcher): Promise<void> {
        if (this.isStarted) return;

        this.isStarted = true;

        this.dispatcher = dispatcher;
        const conn = await this.hubConnectionManager.getConnectionAsync();
        conn.on("CustomerUpdated", ev => this.onProducerUpdated(ev.customerId, dispatcher));
    }

    private async onProducerUpdated(customerId: string, dispatcher: IDispatcher) {
        const producer = await producerService.getProducer(customerId);
        dispatcher.dispatch(new ProducerUpdated(producer).toObject());
    }
}

const producerEventStreamingService: IProducerEventStreamingService = new ProducerEventStreamingService();
export default producerEventStreamingService;